import React from "react";
import {NavLink} from 'react-router-dom'

const Header = () =>{

    function handleClick() {
        document.querySelector('.mobile-menu').classList.toggle('active')
    }

    return(
        <header className="header">
            <div className="header__inner">
                <a href='/' className="header__logo">
                    PsychTable
                </a>
                <nav className="header__navigation">
                    <ul className="menu">
                        <li className="menu__item">
                            <NavLink to="/create" className="menu__link">About</NavLink>
                        </li>
                        <li className="menu__item">
                            <NavLink to="/links" className="menu__link">Contact</NavLink>
                        </li>
                        <li className="menu__item">
                            <NavLink to="/links" className="menu__link">Get involved</NavLink>
                        </li>
                        <li className="menu__item">
                            <NavLink to="/links" className="menu__link" >News</NavLink>
                        </li>
                    </ul>
                    <a className="sign-in" href='https://psytable-api.herokuapp.com/admin' target="_blank" rel="noopener noreferrer">Sign in/up</a>
                </nav>
            </div>
            <div className="mobile-nav">
                <div className="mobile-nav__header">
                    <a href="https://n383467.yclients.com/company:364764" className="mobile-nav__record">
                        Sign in/up
                    </a>
                    <div className="mobile-nav__btn" onClick={handleClick}>
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                </div>
                <div className="mobile-menu">
                    <ul className="mobile-menu__list">
                        <li className="mobile-menu__item">
                            <a href="/" className="mobile-menu__link">Home</a>
                        </li>
                        <li className="mobile-menu__item">
                            <a href="#about-us" className="mobile-menu__link">About</a>
                        </li>
                        <li className="mobile-menu__item">
                            <a href="#team" className="mobile-menu__link">Contact</a>
                        </li>
                        <li className="mobile-menu__item">
                            <a href="#gallery" className="mobile-menu__link">Get involved</a>
                        </li>
                        <li className="mobile-menu__item">
                            <a href="#services" className="mobile-menu__link">News</a>
                        </li>
                    </ul>
                    <div className="mobile-contact">
                        <div className="mobile-contact__item">
                            <a href="tel:+380960420595" className="mobile-contact__link">+380 96 68 41 151</a>
                        </div>
                        <div className="mobile-contact__item">
                            <a href="/"
                               target="_blank" className="mobile-contact__link">Kyivska St, 77, Zhytomyr, Zhytomyr Oblast, 10001</a>
                        </div>
                        <div className="mobile-contact__item">
                            <a href="https://www.instagram.com/blackpeppers_barbershop/"
                               className="mobile-contact__social">
                                <img src="img/icon/instagram2.png" alt="" />
                            </a>
                            <a href="https://t.me/Black_Peppers_Barbershop" className="mobile-contact__social">
                                <img src="img/icon/telegram2.png" alt="" />
                            </a>
                            <a href="https://www.facebook.com/pages/category/Local-Service/BlackPeppers_Barbershop-105595391251777/"
                               className="mobile-contact__social">
                                <img src="img/icon/facebook.png" alt="" />
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </header>

    );
};

export default Header;
